import React from 'react';
import { Image } from '@doveit/lego';
import {
  contentStyle,
  stepsStyle,
  pictureStyle,
  stepStyle,
  stepTitleStyle,
  stepDescriptionStyle,
  stepNumberStyle,
} from './HowItWorksSection.style';
import PageSection from '../../../components/page-section/PageSection';
import { TextAlign } from '../../../types';
import { requireFromStaticAsset } from '../../../utils/assetsUtils';

export interface Picture {
  name: string,
  alt: string,
}

export interface Step {
  title: string,
  description: string,
}

export interface HowItWorksSectionProps {
  title: string,
  picture: Picture,
  steps?: Step[],
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({
  title,
  picture,
  steps = [],
}) => (
  <PageSection backgroundColor="neutrals.lighter">
    <PageSection.Wrapper>
      <PageSection.Title textAlign={TextAlign.CENTER}>
        {title}
      </PageSection.Title>
      <PageSection.Block>
        <div css={contentStyle}>
          <div css={stepsStyle}>
            {steps.map((step, i) => (
              <div
                css={stepStyle}
                key={step.title}
              >
                <div css={stepNumberStyle} $last={i + 1 === steps.length}>{i + 1}</div>
                <h3 css={stepTitleStyle}>
                  {step.title}
                </h3>
                <div css={stepDescriptionStyle}>
                  {step.description}
                </div>
              </div>
            ))}
          </div>
          <div css={pictureStyle}>
            <Image
              src={requireFromStaticAsset(picture.name)}
              alt={picture.alt}
              loading="lazy"
            />
          </div>
        </div>
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default HowItWorksSection;
